// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore'; // Import Firestore

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCGa6kJhmm9PM7SNMk3eB0dyq9tF_oGCLE",
  authDomain: "bettingapp-c9999.firebaseapp.com",
  projectId: "bettingapp-c9999",
  storageBucket: "bettingapp-c9999.appspot.com",
  messagingSenderId: "970894040311",
  appId: "1:970894040311:web:7c56fd44a1248050ff47f2",
  measurementId: "G-WLDPE5Q1M6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app); // Initialize Firestore

export { auth, db };

